@if (!allZeroData) {
  <div id="divChart" class="chart-container">
    <canvas id="inPatientAge"> </canvas>
  </div>
}
